import React from 'react';
import { Box, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { StyledTextField } from 'components/Inputs';
import { t } from 'i18next';
import * as S from '../../styles';
import { FILTERS } from '../../TransportCloudTable.consts';

interface TableFiltersProps {
  searchValue: string;
  checkedOnlyMine: boolean;
  loadingDeliveryDateFrom: string;
  loadingDeliveryDateTo: string;
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onOnlyMineChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDateFromChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDateToChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TableFilters: React.FC<TableFiltersProps> = ({
  searchValue,
  checkedOnlyMine,
  loadingDeliveryDateFrom,
  loadingDeliveryDateTo,
  onSearch,
  onOnlyMineChange,
  onDateFromChange,
  onDateToChange,
}) => (
  <S.FixedFiltersContainer>
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        gap: '0.4rem',
        padding: '9px',
        alignItems: 'center',
      }}
    >
      <StyledTextField
        id='date-from'
        size='small'
        label={FILTERS.dateFrom}
        type='date'
        width={135}
        onChange={onDateFromChange}
        value={loadingDeliveryDateFrom}
        InputLabelProps={{ shrink: true, style: { fontSize: '0.7rem' } }}
        inputProps={{
          style: { fontSize: '0.7rem', padding: '6px 10px' },
        }}
        sx={{
          '& fieldset legend span': {
            fontSize: '0.55rem',
            padding: '0 2px',
          },
        }}
      />
      <StyledTextField
        id='date-to'
        size='small'
        label={FILTERS.dateTo}
        type='date'
        onChange={onDateToChange}
        value={loadingDeliveryDateTo}
        width={135}
        InputLabelProps={{ shrink: true, style: { fontSize: '0.7rem' } }}
        inputProps={{
          style: { fontSize: '0.7rem', padding: '6px 10px' },
        }}
        sx={{
          '& fieldset legend span': {
            fontSize: '0.55rem',
            padding: '0 2px',
          },
        }}
      />
      <FormControlLabel
        sx={{
          '& .MuiFormControlLabel-label': {
            fontSize: '0.7rem',
          },
          marginBottom: 0,
          marginLeft: '1rem',
          gap: '2px',
        }}
        control={
          <Checkbox
            checked={checkedOnlyMine}
            onChange={onOnlyMineChange}
            name='onlyMineCheckbox'
            color='primary'
            sx={{ padding: '2px', '& svg': { fontSize: '1rem' } }}
            size='small'
          />
        }
        label={FILTERS.onlyMine}
      />
      <TextField
        placeholder={t('button.search', { ns: 'misc' })}
        type='text'
        size='small'
        sx={{
          marginLeft: 'auto',
          '& input': {
            fontSize: '0.7rem',
            padding: '6px 10px',
          },
          '& .MuiInputLabel-root': { fontSize: '0.7rem' },
        }}
        value={searchValue}
        onChange={onSearch}
      />
    </Box>
  </S.FixedFiltersContainer>
);
